import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListRoles from './components/ListRoles';
import useRoles from './hooks';
import DetailsItem from './components/DetailsItem';

const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: { padding: theme.spacing(1) },
  },
  header: { marginBottom: theme.spacing(2) },
  sidemenuContainer: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: { paddingRight: 0 },
  },
  backButton: {
    marginBottom: theme.spacing(1),
    textTransform: 'none',
    color: theme.palette.text.primary,
    gap: theme.spacing(1),
    '@media (hover: none) and (pointer: coarse)': { minHeight: theme.spacing(5.5) },
  },
}));

const Roles = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  // Below sm (<600px) the list and details share one column (master → detail).
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [returnFocusId, setReturnFocusId] = useState<string>();
  const {
    roles,
    listingMutations,
    listingQueries,
    handleCreateRole,
    handleDeleteRole,
    setSelectedRole,
    selectedRole,
    handleUpdateRole,
  } = useRoles();

  const showList = !isMobile || !selectedRole;

  const handleBackToList = () => {
    setReturnFocusId(selectedRole?._id);
    setSelectedRole(undefined);
  };

  return (
    <Grid container direction="row" className={classes.container}>
      {showList && (
        <Grid item xs={12} sm={4} md={3} lg={2} className={classes.sidemenuContainer}>
          <ListRoles
            roles={roles}
            listingMutations={listingMutations}
            listingQueries={listingQueries}
            handleCreateRole={handleCreateRole}
            handleDeleteRole={handleDeleteRole}
            setSelectedRole={setSelectedRole}
            selectedRole={selectedRole}
            focusRoleId={isMobile ? returnFocusId : undefined}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={8} md={9} lg={10}>
        {selectedRole && (
          <>
            {isMobile && (
              <Button
                autoFocus
                className={classes.backButton}
                onClick={handleBackToList}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
                {t('roles:backToRoles')}
              </Button>
            )}
            <DetailsItem
              selectedRole={selectedRole}
              listingMutations={listingMutations}
              listingQueries={listingQueries}
              handleUpdateRole={handleUpdateRole}
            />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default Roles;
